import styled from 'styled-components';

export const GroupWrapper = styled('span')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
